import 'alpinejs'

window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');

// SimpleBar
require('simplebar/dist/simplebar.min');

// CoreUI
window.coreui = require('@coreui/coreui');

// Boilerplate
require('../plugins');
